import React, { useMemo } from "react";

import { Stack } from "@mui/material";

import CompareScansHeader from "components/CompareVirtualToursHeader";
import { UnityViewer } from "components/UnityViewer";

import { UnityViewerContextProvider } from "contexts/UnityViewerContext";
import { useLoading } from "contexts/LoadingContext";
import Toolbar from "components/ViewerWrapper/Toolbar";
import { useGetOutputQuery } from "api/output/queries/useGetOutputQuery";
import { NewAnnotationDialog } from "containers/VirtualTourViewer/NewAnnotationDialog";
import { DisplayAnnotation } from "containers/VirtualTourViewer/DisplayAnnotation";
import { useAtom } from "jotai";
import { newAnnotationAtom } from "store/atoms/newAnnotation";
import { useGetVirtualTourAnnotationsQuery } from "api/virtual-tour/queries/useGetVirtualTourAnnotationsQuery";
import { useSearchParams } from "react-router-dom";
import ExistingReferenceMeasurements from "containers/VirtualTourViewer/ExistingReferenceMeasurements";
import { useGetVirtualTourReferenceMeasurements } from "api/virtual-tour/queries/useGetVirtualTourReferenceMeasurements";

function CompareVirtualTours() {
  // const [queryParams] = useSearchParams();
  // const scan1 = queryParams.get("scan1");
  // const scan2 = queryParams.get("scan2");
  const { vtourOutputId1, fullscreen } = useLoading();
  const {
    data: output,
    isLoading: outputLoading,
    error: outputError,
  } = useGetOutputQuery(vtourOutputId1);
  const {
    data: annotations,
    isLoading: annotationsLoading,
    error: annotationsError,
  } = useGetVirtualTourAnnotationsQuery(output?.virtualTour?.id || "");
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedAnnotationId = searchParams.get("annotationId");
  const isPublic = useMemo(() => {
    return location.pathname.startsWith("/public");
  }, [location.pathname]);
  const [newAnnotation, setNewAnnotation] = useAtom(newAnnotationAtom);
  const selectedAnnotation = useMemo(
    () => annotations?.find(({ id }) => selectedAnnotationId === id) || null,
    [annotations, selectedAnnotationId]
  );
  const { data: referenceMeasurements } =
      useGetVirtualTourReferenceMeasurements(output?.virtualTour?.id || "");

  return (
    <UnityViewerContextProvider>
      <Stack
        sx={{
          height: "100%",
          position: "relative",
        }}
      >
        <Stack flex={1} alignItems="center" justifyContent="center">
          <Stack
            width={"100%"}
            height="100%"
            gap={"1rem"}
            maxHeight={fullscreen ? "100vh" : "68vh"}
          >
            <Stack
              // ref={ref}
              direction="row"
              width="100%"
              height="100%"
              position="relative"
              borderRadius={5}
            >
              {output && output.virtualTour && newAnnotation && (
                <NewAnnotationDialog
                  tourId={output.virtualTour.id}
                  onClose={() => {
                    console.debug("Closing new annotation dialog");
                    setNewAnnotation(null);
                  }}
                />
              )}
              {fullscreen && <Toolbar isOverlap={true} />}
              {fullscreen && <Toolbar isOverlap={true} />}
              {output && output.virtualTour && !isPublic && (
                <DisplayAnnotation
                  annotation={selectedAnnotation}
                  onClose={() => {
                    setSearchParams((prev) => {
                      const updatedParams = new URLSearchParams(
                        prev.toString()
                      );
                      updatedParams.delete("annotationId");
                      return updatedParams;
                    });
                  }}
                  tourId={output.virtualTour.id}
                />
              )}
              <UnityViewer scanType="biscan" />
            </Stack>
          </Stack>
        </Stack>
        {output?.virtualTour && !output?.virtualTour.isScaled && (
          <ExistingReferenceMeasurements
            isPublic={isPublic}
            referenceMeasurements={referenceMeasurements}
            virtualTourID={output?.virtualTour?.id || ""}
          />
        )}
      </Stack>
    </UnityViewerContextProvider>
  );
}

export default CompareVirtualTours;
